<p-dialog
  [visible]="showViewReviewsDialog"
  (visibleChange)="onFlag('showViewReviewsDialog', $event)"
  [blockScroll]="false"
  [draggable]="false"
  [modal]="true"
  [style]="{
    width: '1040px',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    transform: 'scale(1)',
    position: 'relative'
  }"
  class="video-reviews-dialog"
  styleClass="pitch-modal video-reviews-dialog"
  appendTo="body">
  <app-business-reviews
    (leaveReviewClick)="handleLeaveReviewClick()"
    (showVideo)="playVideo.emit($event)"
    *ngIf="showViewReviewsDialog"
    [business]="currentPitchCard"></app-business-reviews>
</p-dialog>

<div class="col-12 home-banner no-padding upload-review-dialog">
  <p-dialog
    (onHide)="onFlag('showUploadReviewRatingScreen', false)"
    [visible]="showUploadReviewVideoDialog"
    (visibleChange)="onFlag('showUploadReviewVideoDialog', $event)"
    [blockScroll]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    [draggable]="false"
    [modal]="true"
    [style]="{ width: '800px', maxWidth: '100%' }"
    styleClass="mi-mob-fullscreen-dialog"
    appendTo="body">
    <app-upload-video-steps
      (next)="moveToUploadReviewRatingScreen($event)"
      *ngIf="!showUploadReviewRatingScreen && showUploadReviewVideoDialog"
      [businessType]="
        this.currentPitchCard.businessType
      "></app-upload-video-steps>
    <div *ngIf="showUploadReviewRatingScreen" class="review-screen">
      <div class="main-title" translate>label_upload_testimonial</div>
      <div class="grid add-business-form mt-30">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="box-wrap">
            <div class="video-img-thumb"></div>
            <div
              class="text-center relative border-1 border-gray-50 border-round flex bg-black"
              style="--border-radius: 4px">
              <img
                #coverImage
                (load)="calcCover()"
                [ngStyle]="{
                  'object-fit': isCoverLandscape ? 'cover' : 'contain',
                  maxHeight: coverImageHeight ? coverImageHeight : ''
                }"
                [src]="
                  uploadReviewVideoMetaData?.thumnailUrl
                    ? uploadReviewVideoMetaData.thumnailUrl +
                      '?time=1&fit_mode=smartcrop'
                    : 'assets/images/home-banner-image.jpg'
                "
                alt="thumbnail"
                class="h-auto w-12" />
              <div
                (click)="playVideo.emit(uploadReviewVideoMetaData?.videoUrl)"
                *ngIf="uploadReviewVideoMetaData?.videoUrl"
                class="overlay-camera">
                <span class="sprite big-video"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid col-12 justify-content-between pb-0 pl-0 pr-0 ml-0 mr-0 mt-20">
        <button
          pButton
          (click)="updateUploadedReviewVideo()"
          class="button-simple primary-btn"
          translate>
          label_reupload_video
        </button>
        <button
          pButton
          (click)="submitUploadedVideoReview()"
          class="button-simple shock-pink"
          translate>
          label_submit
        </button>
      </div>
    </div>
  </p-dialog>
</div>
